import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const UserUpdate = lazy(() => import('../../container/user/userUpdate'));
const UserDetails = lazy(() => import('../../container/user/userDetail/userDetails'));

function PagesRoute() {
  return (
    <Routes>
      <Route path="details/:id" element={<UserDetails />} />
      <Route path="update/:id" element={<UserUpdate />} />
    </Routes>
  );
}

export default PagesRoute;
